module.exports = __webpack_public_path__ + "static/img/company_introduction.9e3f19c9.png";